/* eslint-disable @typescript-eslint/no-use-before-define */
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { buildURI } from '@hn-front/utils';
import { useAppGoogleAnalytics } from '../../../shared_app/hooks/useAppGoogleAnalytics';
import { curriculumTabs } from '../constants/texts';
import { useFetchCurriculumGrade } from './useFetchCurriculumGrade';
import { useCurrentRoute } from './useCurrentRoute';
var useCurriculum = function () {
    var _a;
    var _b = useState(), activeTopicId = _b[0], handleChangeTopic = _b[1];
    var _c = useParams(), groupId = _c.groupId, gradeName = _c.gradeName;
    var navigate = useNavigate();
    var currentTab = (_a = curriculumTabs.find(function (x) { return x.value === gradeName; })) !== null && _a !== void 0 ? _a : curriculumTabs[0];
    var description = currentTab.description;
    var _d = useFetchCurriculumGrade(gradeName), gradeData = _d.response, fetchState = _d.state;
    var currentRoute = useCurrentRoute();
    var handleChangeGrade = useCallback(function (_a) {
        var value = _a.value;
        navigate(buildURI(currentRoute, { pathParams: { groupId: groupId, gradeName: value } }));
    }, [currentRoute, groupId, navigate]);
    useCurriculumMetaTags(description, gradeName);
    useRemoveOldCurriculumVersion();
    useAppGoogleAnalytics();
    return {
        groupId: groupId,
        activeTopicId: activeTopicId,
        handleChangeTopic: handleChangeTopic,
        gradeData: gradeData,
        fetchState: fetchState,
        handleChangeGrade: handleChangeGrade,
        currentRoute: currentRoute,
        currentTab: currentTab,
    };
};
var useCurriculumMetaTags = function (description, gradeName) {
    useEffect(function () {
        if (!gradeName)
            return;
        document
            .querySelectorAll('[rel="canonical"]')[0]
            .setAttribute('href', window.location.protocol + "//" + window.location.hostname + "/math/" + gradeName);
    }, [gradeName]);
    useEffect(function () {
        document
            .querySelectorAll('[property="og:description"]')[0]
            .setAttribute('content', "" + description);
    }, [description]);
};
// We render slim version only for SEO purposes, then remove it when the app is loaded
var useRemoveOldCurriculumVersion = function () {
    useEffect(function () {
        var oldVersion = window.document.querySelector('.early-content');
        if (oldVersion) {
            oldVersion.remove();
        }
    }, []);
};
export { useCurriculum };
